export enum GACodes {
    ACTION_ORG_PAGE_VIEW = 'OrganizerPageView',
    LABEL_ORG_PANEL = 'OrganizerPanel',
}
